import React from 'react';

import PropTypes from 'prop-types';
import { Button, Typography } from '@material-ui/core';

import Modal from '../../common/Modal';

function DeleteTagModal({ open, onClose, onConfirm }) {
  return (
    <Modal open={open} onClose={onClose}>
      <Typography variant="body1" className="text-center">Delete all tag(s)?</Typography>
      <div className="d-flex mt-3 justify-content-around">
        <Button variant="contained" color="primary" onClick={onClose}>Cancel</Button>
        <Button color="secondary" onClick={onConfirm}>Proceed</Button>
      </div>
    </Modal>
  );
}

DeleteTagModal.propTypes = {
  open:      PropTypes.bool.isRequired,
  onClose:   PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default DeleteTagModal;
